import { useAdvisorDetailQuery } from "web_myplann/Api/Advisor/useAdvisorDetailQuery";
import { useChatListQuery } from "web_myplann/Api/Chat/useChatListQuery";

export const useChatRecipient = (
	conversationId: number | null,
	advisorId?: string,
) => {
	const { data: conversations = [], isLoading: isChatListLoading } =
		useChatListQuery();
	const { data: advisor, isLoading: isAdvisorLoading } =
		useAdvisorDetailQuery(advisorId);

	const conversation = conversations.find((item) => item.id === conversationId);
	const participant = conversation?.participants?.find(
		(item) => item.type !== "client",
	);

	return {
		advisorId: advisorId ?? participant?.id,
		advisorName: advisor?.name ?? conversation?.title ?? "",
		advisorPhoto: advisor?.avatar ?? undefined,
		isLoading:
			(conversationId !== null && isChatListLoading) ||
			(Boolean(advisorId) && isAdvisorLoading),
	};
};
